import { useNavigate } from 'react-router-dom';
import Footer from '../../../components/Footer';
import { Layout } from '../../../components/layout';
import ButtonBack from '../../../components/ui/buttonBack';
import {
	choosePlatform,
	choosePlatformDomainName,
	choosePlatformName,
} from '../../../helpers/utils';

export const Rules = () => {
	const navigate = useNavigate();

	return (
		<Layout customBG="bg-background-dark" logoWhite>
			<div className="px-3.5 pt-7 pb-7 lg:max-w-screen-xl lg:mx-auto">
				<div className="items-center flex-row flex justify-between px-3.5 pt-10 pb-6 lg:flex-col lg:justify-start lg:items-start lg:gap-4">
					<ButtonBack classNameIcon="text-custom-white" />
					<p
						className={
							'text-xl font-semibold text-center font-bahnschrift text-custom-white lg:text-left' +
							(choosePlatform()
								? ' lg:text-white'
								: ' lg:text-primary')
						}
					>
						Regulamento
					</p>
					<div></div>
				</div>

				<div className="text-sm text-left text-custom-gray4 font-bahnschrift lg:rounded-lg lg:bg-custom-gray2 lg:p-8">
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							1. Descrição do Torneio
						</span>
					</p>
					<br />O {choosePlatformName()} é um desafio de game fantasy
					onde você monta seus times e responde a perguntas,
					permitindo que cada participante mostre suas habilidades e
					conhecimentos sobre seus times favoritos ou sobre esportes
					em geral. Os inscritos são recompensados de acordo com a
					habilidade e precisão das respostas.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							2. Elegibilidade
						</span>
					</p>
					<br />
					Podem participar do torneio pessoas com 18 anos ou mais e
					residência no Brasil. Funcionários da {choosePlatformName()}
					, assim como seus familiares diretos, estão proibidos de
					participar.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							3. Como Participar
						</span>
					</p>
					<br />- Para participar, o usuário deve pagar a taxa de
					inscrição de cada torneio, cobrada pelo app{' '}
					{choosePlatformName()}, e se inscrever nos torneios
					disponíveis.
					<br />
					<br />
					- O valor da inscrição pode ser debitado da sua carteira de
					bônus, do saldo real ou de ambas. Para garantir que o
					usuário aproveite ao máximo as vantagens oferecidas pelo
					bônus, o uso dele sempre será priorizado. Somente após isso,
					o débito será feito no saldo real.
					<br />
					<br />
					- Visando concluir sua inscrição e garantir a participação
					no torneio, é necessário montar os times conforme as
					propostas de cada evento e, caso haja perguntas,
					respondê-las com base em seus conhecimentos e na análise dos
					eventos relacionados. Somente após concluir essas etapas,
					você poderá finalizar sua inscrição.
					<br />
					<br />
					<span className="font-bold text-left italic text-custom-white font-bahnschrift">
						A que se referem as inscrições:
					</span>
					<br />
					- Alguns torneios exigem um número mínimo de inscrições para
					serem realizados. Caso esse número não seja atingido, o
					torneio será cancelado e os inscritos receberão reembolso
					integral na carteira do app.
					<br />
					<br />
					- Quando o número mínimo de inscrições não for definido
					durante a criação do torneio, ele será classificado como
					GARANTIDO, ou seja, ocorrerá independentemente do número de
					inscrições realizadas.
					<br />
					<br />
					- Os torneios podem ter uma quantidade máxima de inscritos,
					limitando as participações e dando prioridade aos usuários
					mais atentos.
					<br />
					<br />
					<span className="font-bold text-left text-custom-white font-bahnschrift">
						Atenção:
					</span>{' '}
					todos os detalhes estarão visíveis no card principal de cada
					torneio.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							4. Estrutura dos torneios.
						</span>
					</p>
					<br />
					<span className="font-bold text-left italic text-custom-white font-bahnschrift">
						Escalação dos times:
					</span>
					<br />
					<br />
					Cada torneio incluirá times a serem escalados, com no mínimo
					dois jogadores (variando conforme o torneio), podendo contar
					com reservas ou não. O usuário deve analisar atentamente os
					scouts disponíveis para o time e os eventos relacionados ao
					torneio ao fazer suas escolhas.
					<br />
					<br />
					<span className="font-bold text-left text-custom-white font-bahnschrift">
						Atenção:
					</span>{' '}
					Caso haja banco de reservas, os jogadores serão substituídos
					automaticamente se um dos titulares da mesma posição não
					entrar em campo.
					<br />
					<br />
					<span className="font-bold text-left italic text-custom-white font-bahnschrift">
						Perguntas sobre os eventos do torneio:
					</span>
					<br />
					<br />
					Um torneio poderá incluir perguntas relacionadas aos eventos
					vinculados a ele, com respostas no formato SIM ou NÃO. Cada
					alternativa terá uma pontuação determinada pelo nível de
					dificuldade. O usuário deve aplicar sua habilidade para
					analisar e escolher a melhor resposta. Caso a alternativa
					escolhida se concretize no evento, a pontuação será
					adicionada ao total da inscrição.
					<br />
					<br />
					<span className="font-bold text-left italic text-custom-white font-bahnschrift">
						Perguntas sobre os eventos do torneio:
					</span>
					<br />
					<br />
					Um torneio poderá incluir perguntas relacionadas aos eventos
					vinculados a ele, com respostas no formato SIM ou NÃO. Cada
					alternativa terá uma pontuação determinada pelo nível de
					dificuldade. O usuário deve aplicar sua habilidade para
					analisar e escolher a melhor resposta. Caso a alternativa
					escolhida se concretize no evento, a pontuação será
					adicionada ao total da inscrição.
					<br />
					<br />
					<span className="font-bold text-left italic text-custom-white font-bahnschrift">
						Perguntas sobre os eventos do torneio:
					</span>
					<br />
					<br />
					Alguns torneios serão identificados com o selo Jogo Único, o
					que significa que estão vinculados a um único evento real.
					Isso torna o torneio mais dinâmico, garantindo agilidade na
					apuração dos resultados e, consequentemente, na liberação
					dos prêmios.
					<br />
					<br />
					Torneios identificados como Entrada Única permitirão apenas
					uma inscrição por usuário, exigindo mais estratégia e
					critério nas respostas dos participantes e garantindo
					igualdade de chances a todos.
					<br />
					<br />
					A fim de garantir uma competição justa para todos, alguns
					torneios terão o selo Novato. Isso significa que somente
					novos usuários ou aqueles que ainda não avançaram de nível
					poderão se inscrever neles.
					<br />
					<br />
					<span className="font-bold text-left text-custom-white font-bahnschrift">
						Atenção:
					</span>{' '}
					Todos estes detalhes estarão sempre visíveis no card
					principal de cada torneio.
					<br />
					<br />
					<span className="font-bold text-left italic text-custom-white font-bahnschrift">
						A que se referem suspensão, adiamento e cancelamento de
						eventos associado a um torneio:
					</span>
					<br />
					<br />
					<span className="font-bold text-left text-custom-white font-bahnschrift">
						Suspenso:
					</span>{' '}
					se o evento suspenso não continuar até as 23h59 do dia
					seguinte, a {choosePlatformName()} aplicará as seguintes
					regras:
					<br />
					<br />
					Para eventos que fazem parte de um torneio de Jogo Único:
					<br />
					- Caso a suspensão ocorra no primeiro tempo do jogo, o
					torneio será cancelado e o valor da inscrição será
					reembolsado.
					<br />
					- Se a suspensão ocorrer no intervalo ou no segundo tempo do
					jogo, o torneio seguirá normalmente, considerando a
					pontuação no momento da suspensão.
					<br />
					<br />
					Se o torneio envolver dois ou mais eventos e um deles for
					suspenso:
					<br />
					- Caso a suspensão ocorra no primeiro tempo do jogo, o
					evento será cancelado e o torneio continuará normalmente,
					considerando as estatísticas dos demais eventos.
					<br />
					- Se a suspensão ocorrer no intervalo ou no segundo tempo do
					jogo, o torneio seguirá normalmente, considerando a
					pontuação no momento da suspensão, além dos demais eventos
					do torneio.
					<br />
					<br />
					<span className="font-bold text-left text-custom-white font-bahnschrift">
						Adiado ou Cancelado:
					</span>{' '}
					se um evento de um torneio for adiado ou cancelado e
					remarcado para um horário dentro do período de apuração
					original, ele será mantido, e as escolhas feitas pelos
					jogadores serão preservadas.
					<br />
					<br />
					No entanto, se o evento for remarcado para um horário fora
					do período de pontuação previsto inicialmente, a{' '}
					{choosePlatformName()}
					aplicará as seguintes regras:
					<br />
					<br />
					Para eventos que fazem parte de um torneio de Jogo Único:
					<br />
					- O torneio será cancelado e o valor da inscrição será
					reembolsado.
					<br />
					<br />
					Se o torneio envolver dois ou mais eventos e um deles for
					suspenso:
					<br />
					- O evento será removido do torneio, e tanto os jogadores
					quanto as perguntas não contarão pontos.
					<br />
					<br />
					<span className="font-bold text-left text-custom-white font-bahnschrift">
						Atenção:
					</span>{' '}
					ocasionalmente, os marcadores oficiais podem corrigir
					estatísticas após o término dos jogos e da validação oficial
					da pontuação. Essas correções são raras, mas podem ocorrer
					dias após o jogo ser disputado, porém, não afetarão as
					disputas finalizadas. Por outro lado, se um bug no feed de
					dados ou no processo de finalização da{' '}
					{choosePlatformName()} for identificado, a finalização e o
					pagamento poderão ser revertidos e corrigidos mesmo após o
					encerramento das disputas.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							5. Premiação
						</span>
					</p>
					<br />
					- A premiação será baseada em acertos a cada torneio, sem
					pontuação cumulativa. A pontuação dos jogadores é baseada em
					um conjunto de scouts (sempre disponíveis no time a ser
					montado). Os scouts avaliam o desempenho de cada jogador
					durante o torneio e determinam a quantidade de pontos que
					ele acumula. Fique atento, os critérios de avaliação estarão
					sempre à disposição para ajudar na escolha dos melhores
					jogadores para a sua equipe.
					<br />
					<br />
					- Em alguns torneios, pode ser necessário escolher um
					capitão para o time. O capitão tem a pontuação dobrada, ou
					seja, tudo o que ele fizer conta duas vezes mais para o
					time.
					<br />
					<br />
					- Quando um jogador titular não pontuar em um time, ele será
					automaticamente substituído por um jogador reserva. Essa
					troca acontece para garantir que o time continue com o
					melhor desempenho possível durante o torneio.
					<br />
					<br />
					- Os prêmios podem variar entre dinheiro, bônus exclusivos
					no aplicativo, produtos e vales-presente. A lista completa
					de prêmios será divulgada no início de cada torneio,
					juntamente com as datas de início e término, conforme o
					horário de Brasília.
					<br />
					<br />
					<b>
						- Os torneios não são de forma alguma patrocinados,
						administrados, endossados ou associados à Apple Inc (App
						Store) ou à Google LLC (Google Play). Tanto a Google LLC
						(Google Play) quanto a Apple Inc (App Store) estão
						completamente isentas de qualquer responsabilidade em
						relação ao torneio, sendo a responsabilidade unicamente
						da empresa {choosePlatformName()}.
					</b>
					<br />
					<br />
					A tabela que detalha o percentual e valor da distribuição de
					prêmios de cada torneio está disponível na aba “Premiação”.
					<br />
					<br />
					<span className="font-bold text-left text-custom-white font-bahnschrift">
						Atenção:
					</span>
					<br />
					1. As regras de premiação poderão ser atualizadas
					periodicamente e é importante que os usuários leiam as
					condições de cada torneio para entender as especificidades
					do sistema de premiação vigente.
					<br />
					<br />
					2. Os scouts fornecidos para a pontuação dos jogadores são
					enviados por uma empresa de confiança e referência no
					mercado. Essa parceria garante a legitimidade e a precisão
					dos dados utilizados, oferecendo uma avaliação justa e
					transparente do desempenho de cada jogador.{' '}
					<span
						onClick={() => {
							const link = document.createElement('a');
							link.href = 'https://www.footstatsi2a.com';
							link.target = '_blank';
							link.click();
						}}
						className="cursor-pointer"
					>
						www.footstatsi2a.com
					</span>
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							6. Política de Reembolso
						</span>
					</p>
					<br />
					Não haverá reembolso após a inscrição, exceto em caso de
					cancelamento do torneio pela {choosePlatformName()}.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							7. Termos Gerais
						</span>
					</p>
					<br />- A {choosePlatformName()} reserva-se o direito de
					modificar ou cancelar o torneio em circunstâncias
					excepcionais.
					<br />
					- Qualquer violação das regras resultará na desclassificação
					do participante.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							8. Contato
						</span>
					</p>
					<br />
					Para dúvidas ou suporte, entre em contato pelo e-mail:{' '}
					<a
						href={`mailto:suporte@${choosePlatformDomainName()}`}
						className="cursor-pointer font-bold"
					>
						{`suporte@${choosePlatformDomainName()}`}
					</a>
					<br />
					<br />
				</div>
			</div>

			<Footer />
		</Layout>
	);
};
